import { imageUrl } from "@/lib/api";

// Unified Tenant Logo Resolver — SATU sumber kebenaran untuk seluruh area
// (storefront header, login/register/forgot/reset, account, admin header/sidebar,
// accept invitation, branding preview).
// Precedence final: logo_horizontal → logo → generated tenant mark → tenant initial.
const LEGACY_DEFAULT = "/brand/logo-horizontal.svg";

export function resolveTenantLogo(visual, name = "") {
  const v = visual || {};
  if (v.logo_horizontal) {
    return { type: "horizontal", src: imageUrl(v.logo_horizontal) };
  }
  if (v.logo && v.logo !== LEGACY_DEFAULT) {
    return { type: "icon", src: imageUrl(v.logo) };
  }
  if (v.logo === LEGACY_DEFAULT) {
    // Legacy default tenant (Sinar Telur) — mark bawaan.
    return { type: "icon", src: "/brand/mark.svg" };
  }
  const initial = (name || "").trim().charAt(0).toUpperCase();
  if (initial) {
    return { type: "initial", src: "", initial };
  }
  return { type: "icon", src: "/brand/dynicty-mark.svg" };
}

export function validLogoScale(scale) {
  return ["small", "medium", "large", "xl"].includes(scale) ? scale : "medium";
}
